import type {ReactElement, ReactNode} from 'react';
import React from 'react';
import styles from './contextual-menu-header.module.scss';

interface ContextualMenuHeaderProps {
  id: string;
  className?: string;
  children: ReactNode;
}

export function ContextualMenuHeader({className = '', ...props}: ContextualMenuHeaderProps): ReactElement<any> | null {
  return (
    <div id={props.id} className={`${styles.header} flex-center ${className}`}>
      {props.children}
    </div>
  );
}
